export const isValidSiret = (siret: string) => {
  const regex = /^\d{3}\s*\d{3}\s*\d{3}\s*\d{5}$/gm;
  return regex.test(siret);
};
